import React from "react";
import { useTranslation } from "react-i18next";
import { CheckoutStep } from "../checkoutSlice";
import Icon from "../../../../common/components/Icon/Icon";

interface CheckoutProgressProps {
  currentStep: CheckoutStep;
  needsShipping: boolean;
}

const CheckoutProgress: React.FC<CheckoutProgressProps> = ({
  currentStep,
  needsShipping,
}) => {
  const { t } = useTranslation();

  const allSteps: { key: CheckoutStep; label: string; icon: string }[] = [
    {
      key: "billing",
      label: t("checkoutProgress.billing", "Billing"),
      icon: "receipt-text",
    },
    {
      key: "shipping",
      label: t("checkoutProgress.shipping", "Shipping"),
      icon: "truck",
    },
    {
      key: "payment",
      label: t("checkoutProgress.payment", "Payment"),
      icon: "credit-card",
    },
  ];

  // Dynamically filter steps based on cart needs
  const activeSteps = allSteps.filter(
    (step) => step.key !== "shipping" || needsShipping,
  );

  const stepKeys = activeSteps.map((s) => s.key);
  const currentIndex = stepKeys.indexOf(currentStep);

  return (
    <div className="checkout-progress">
      <div className="checkout-progress__track">
        {activeSteps.map((step, index) => {
          const isCompleted = index < currentIndex;
          const isActive = index === currentIndex;

          let modifierClass = "";
          if (isCompleted) modifierClass = "is-completed";
          else if (isActive) modifierClass = "is-active";

          return (
            <div
              key={step.key}
              className={`checkout-progress__step ${modifierClass}`}
            >
              <div className="checkout-progress__icon-wrapper">
                {isCompleted ? (
                  <Icon iconName="check" className="icon--stroke-thickest" />
                ) : (
                  <Icon iconName={step.icon} className="icon--stroke-thicker" />
                )}
              </div>

              <span className="checkout-progress__label">{step.label}</span>

              {/* Connecting Line */}
              <div className="checkout-progress__line"></div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CheckoutProgress;
